import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import IpadNavigation from 'Navigation/IpadNavigation'
import {InvoiceRowView as InvoiceRow} from './Smartphones'

// Helpers
import getLeftComponent from 'Navigation/helpers/linkAccordance'

export class InvoiceRowView extends Component {
  static propTypes = {
    t: PropTypes.func,
    previousLink: PropTypes.string
  }

  render () {
    const {t, previousLink} = this.props
    const Events = getLeftComponent('invoice', previousLink)

    return (
      <IpadNavigation {...this.props} title={t('navbar', 'title').s}>
        <Events {...this.props} />
        <InvoiceRow {...this.props} />
      </IpadNavigation>
    )
  }
}

function mapStateToProps (state) {
  return {
    t: state.i18n.get('app', 'views', 'Invoices', 'InvoiceRowView'),
    previousLink: state.appInfo.previousLink
  }
}

export default connect(mapStateToProps)(InvoiceRowView)
